export const supportedExtensions = ["txt", "sol", "ts", "js", "md", "json"];
